module.exports = __webpack_public_path__ + "img/logo-bg.c6b73088.png";